import { AICompletionType } from "@/graphql/schema";
import { useMemo } from "react";
import { AI_PROMPT_PARAMS_MAP_RUNTIME } from "./constants";

export const useAITeacherTools = ({ settings, tool }) => {
    const filteredSettingsPerTool = useMemo(() => {
        const validKeys = Object.keys(AI_PROMPT_PARAMS_MAP_RUNTIME[AICompletionType[tool]] || {});

        return Object.keys(settings)
            .filter(key => validKeys.includes(key))
            .reduce((obj, key) => {
                obj[key] = settings[key];
                return obj;
            }, {});
    }, [settings, tool]);

    const filteredCleanedSettingsPerTool = useMemo(() => {
        const cleanFilteredSettings = Object.keys(filteredSettingsPerTool).reduce((cleaned, key) => {
            const selectTypeKeys = [
                "textLengthUnit",
                "settings",
                "requireMaterials",
                "lengthOfSummary",
                "relationShipToRecipient",
                "tone",
            ];
            const value = settings[key];

            // Handle specific fields
            if (key === "grade" && value?.label) {
                cleaned[key] = value.label;
            } else if (key === "pointScale" && value?.label) {
                cleaned[key] = value.label;
            } else if (key === "time" && value) {
                cleaned[key] = `${value} minutes`;
            } else if (key === "textLength" && value) {
                cleaned[key] = `${value} ${settings.textLengthUnit.label}`;
            } else if (selectTypeKeys.includes(key) && value) {
                cleaned[key] = value.value;
            } else if (key === "textType" && value) {
                cleaned[key] = value.label;
            } else {
                cleaned[key] = value; // Retain other values as-is
            }

            return cleaned;
        }, {});

        return cleanFilteredSettings;
    }, [settings, tool, filteredSettingsPerTool]);

    return {
        filteredCleanedSettingsPerTool,
        filteredSettingsPerTool,
    };
};
